export default "/assets/images/mila-room-showcase-sm-02.jpg?cfc3d828ae820bf867488c3ca2f960a4";